var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"burger-button",class:{ 'burger-button--active' : _vm.open },on:{"click":function($event){return _vm.$store.commit('mobile-menu/setOpened', !_vm.open)}}},[_c('div',{staticClass:"burger-button__line"})])}
var staticRenderFns = []

export { render, staticRenderFns }